export enum WtrColors {
  PrimaryColor = 'primary-color',
  NeutralColorBlack2 = 'neutral-color-black-2',
  NeutralColorWhite = 'neutral-color-white',
  NavBarIconColor = 'nav-bar-icon-color',
  SuccessColor = 'success-color',
  ErrorColor = 'error-color',
}
